<template>
    <div>
        <ValidationObserver ref="formValidate">
            <b-row>
                <b-col md="12">
                    <b-card>
                        <b-row>
                            <b-col sm="12" md="12">
                                <ValidationProvider name="slug" rules="required" v-slot="{valid, errors}">
                                    <b-form-group :label="$t('slug')">
                                        <b-form-input
                                            v-model="formData.slug"
                                            :state="errors[0] ? false : (valid ? true : null)" />
                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col sm="12" md="6">
                                <ValidationProvider name="header" rules="required" v-slot="{valid, errors}">
                                    <b-form-group :label="$t('header')">
                                        <b-form-input
                                            v-model="formData.header"
                                            :state="errors[0] ? false : (valid ? true : null)" />
                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col sm="12" md="6">
                                <ValidationProvider name="header_en" rules="required" v-slot="{valid, errors}">
                                    <b-form-group :label="$t('header')+' (EN)'">
                                        <b-form-input
                                            v-model="formData.header_en"
                                            :state="errors[0] ? false : (valid ? true : null)" />
                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col sm="12" md="6">
                                <ValidationProvider name="rank" rules="required" v-slot="{valid, errors}">
                                    <b-form-group :label="$t('rank')">
                                        <b-form-input
                                            type="number"
                                            v-model="formData.rank"
                                            :state="errors[0] ? false : (valid ? true : null)" />
                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col sm="12" md="3">
                                <ValidationProvider name="is_visible" rules="required" v-slot="{errors}">
                                    <b-form-group :label="$t('visibility')">
                                        <multi-selectbox
                                            v-model="formData.is_visible"
                                            :multiple="false"
                                            :options="boolOptions"
                                            :validate-error="errors[0]"/>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col sm="12" md="3">
                                <ValidationProvider name="is_active" rules="required" v-slot="{errors}">
                                    <b-form-group :label="$t('status')">
                                        <multi-selectbox
                                            v-model="formData.is_active"
                                            :multiple="false"
                                            :options="boolOptions"
                                            :validate-error="errors[0]"/>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col sm="12" md="12">
                                <ValidationProvider name="description" rules="" v-slot="{errors}">
                                    <b-form-group :label="$t('content')">
                                        <ck-editor-input
                                            v-model="formData.description"
                                            :validateError="errors[0]"/>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col sm="12" md="12">
                                <ValidationProvider name="description_en" rules="" v-slot="{errors}">
                                    <b-form-group :label="$t('content')+' (EN)'">
                                        <ck-editor-input
                                            v-model="formData.description_en"
                                            :validateError="errors[0]"/>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>
            </b-row>

            <div class="d-flex justify-content-center mt-2">
                <b-button
                    variant="primary"
                    @click="save"
                    :disabled="formLoading">
                    {{ $t("save") }}
                </b-button>
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
// Components
import MultiSelectbox from "@/components/interactive-fields/MultiSelectbox"
import CkEditorInput from "@/components/elements/CkEditorInput"

// Services
import EctsService from "@/services/EctsService"

// Other
import { ValidationObserver, ValidationProvider } from "vee-validate";


export default {
    components: {
        ValidationObserver,
        ValidationProvider,
        MultiSelectbox,
        CkEditorInput
    },
    props: {
        parentData: {
            type: Object,
        },
        updateData: {
            type: Object,
        }
    },
    data() {
        return {
            formLoading: false,
            formData: {},
            boolOptions: [
                {
                    text: this.$t('active'),
                    value: 1
                },
                {
                    text: this.$t('passive'),
                    value: 0
                }
            ]
        };
    },

    created() {
        this.formData = {}
        if(this.updateData) {
            this.formData = this.updateData
            this.formData.desription = this.decodeHTMLEntities(this.formData.desription)
        }
    },

    methods: {
        async save(){
            const isValid = await this.$refs.formValidate.validate();
            if (isValid) {
                if (this.updateData) {
                    EctsService.updatePages(this.formData, this.updateData.id).then(response => {
                        this.$toast.success(this.$t('api.'+response.data.message))
                        this.$emit('onStore', true)
                    }).catch(e => {
                        this.showErrors(e, this.$refs.formValidate)
                    })
                } else {
                    this.formData.parent_id = this.parentData ? this.parentData.id : null
                    EctsService.storePages(this.formData).then(response => {
                        this.$toast.success(this.$t('api.'+response.data.message))
                        this.$emit('onStore', true)
                    }).catch(e => {
                        this.showErrors(e, this.$refs.formValidate)
                    })
                }
            }
        }
    },
}
</script>
